import { ContactForm } from '@/app/components/ContactForm'
import { TRACKING_LOCATIONS } from '@/app/utils/analytics'
import type { ContactForm as ContactFormProps } from '@/sanity.types'

type ContactFormSectionProps = {
  block: ContactFormProps & { _key?: string }
  index: number
  pageId?: string
  pageType?: string
}

export default function ContactFormSection({ block, pageId, pageType }: ContactFormSectionProps) {
  return (
    <ContactForm
      contactForm={block}
      tracking={{ location: TRACKING_LOCATIONS.PAGE_CONTENT }}
      documentId={pageId}
      documentType={pageType}
      parentPath="pageBuilder"
    />
  )
}
